import React from 'react'
import Navbar from '../../components/navbar/Navbar'
import PurchaseReport from '../../components/reports/PurchaseReport'

const PurchasePage = () => {
    return (
        <>
            <section className="bajaj_main_block">
                <div className="container-fluid">
                    {/* Navbar */}
                    <div className="row">
                        <div className="col-12 p-0">
                            <Navbar content="PURCHASE REPORT" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 p-0">
                            <PurchaseReport />
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default PurchasePage